<div
  data-rr-shared="true"
  [appStoryblok]="_editable()"
  [backgroundColor]="read_more_background_color().value"
  [maxBodyHeight]="maxHeight()"
  [showFadeOut]="read_more_show_fade_out()"
  [useReadMore]="read_more_active()"
  app-read-more
  eventSourceName="storyblok-card"
  class="row">
  @for (blok of body(); track blok._uid) {
    @if (components) {
      <ng-template [ndcDynamicInputs]="blok"
                   [ngComponentOutlet]="components[blok.component]"></ng-template>
    }
  }
</div>
